import {required, email, or, maxLength } from '@rxweb/reactive-form-validators';

export class RecoverModel {
    @required({ message: 'Este campo es obligatorio.' })
    @maxLength({ value: 255, message: 'El correo debe tener máximo 255 caracteres.' })
    @or({
        validation: {
          email:  { message: "Ingrese una dirección de correo válida." },
          pattern: {
            expression: {
              alphaNumeric: /^3[0-9]{9}$/,
            },
            message: "El número no es válido.",
          }
        },
        message: "Por favor ingresa un número de celular de 10 dígitos o un correo válido (ej. nombre@dominio.com)."
    })
    email: string;
}